import {Link} from 'react-router-dom';
import styled, { css } from 'styled-components';

export const FullScreen = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0,0,0,0.5);
    z-index: ${(props)=>(props?.zIndex)?props.zIndex:500};
`;

export const WhiteBox = styled.div`
    width: calc(100vw * (284 / 375));
    border-radius: calc(100vw * (10 / 375));
    background: #fff;
    overflow: hidden;
`;

export const ModalContentArea = styled.div`
    width: 100%;
    padding: calc(100vw * (27 / 375)) calc(100vw * (24 / 375)) calc(100vw * (20 / 375)) calc(100vw * (24 / 375));
`;

export const ModalTitle = styled.h3`
    font-size: calc(100vw*(18/375));
    font-weight: 700;
    color: #121212;
    text-align: center;
    margin-bottom: calc(100vw * (13 / 375));
`;

export const ModalDescription = styled.p`
    font-size: calc(100vw*(14/375));
    line-height: calc(100vw * (20 / 375));
    color: #4E4E4E;
    text-align: center;
    white-space: pre-wrap;

    margin-bottom: calc(100vw * (22 / 375));
`;

export const ButtonListArea = styled.div`
    display: flex;
    
`;  

const buttonStyle = css`
    width: 100%;
    padding: calc(100vw * (10 / 375));
    color: #121212;
    border-radius: calc(100vw * (8 / 375));
    font-weight: 500; 
    background: #FFCF19;
`; 

export const ButtonStyle = styled.button`
    ${buttonStyle}; 
`;

export const CanceButtonStyle = styled(ButtonStyle)`
    background: #EFEFEF;
    color: #4E4E4E;
    margin-right: calc(100vw * (9 / 375));
`;

export const LinkStyle = styled(Link)`
    ${buttonStyle};
    text-align: center;
    line-height: normal;
`;

export const KakaoChatWrapper = styled.div``;

export const KakaoChatLink = styled(Link)

``;